module.exports = __webpack_public_path__ + "static/media/car-garage.225e21e4.svg";